var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCupom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4464_31118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3581 2.07852L15.5549 1.27538C15.2242 0.944667 14.6927 0.944667 14.362 1.27538L1.27538 14.3738C0.944667 14.7045 0.944667 15.236 1.27538 15.5667L2.06671 16.3581C2.35018 16.6415 2.78719 16.6769 3.1179 16.4644C3.74388 16.0628 4.52341 15.8974 5.33837 16.0628C6.60215 16.3226 7.59427 17.4447 7.70057 18.7321C7.75963 19.4171 7.58246 20.0667 7.25175 20.5864C7.03915 20.9289 7.07459 21.3659 7.35805 21.6494L8.42105 22.7124C8.75175 23.0431 9.28325 23.0431 9.61396 22.7124L22.7006 9.62577C23.0313 9.29506 23.0313 8.76356 22.7006 8.43285L21.6258 7.35805C21.3423 7.07459 20.9171 7.03915 20.5864 7.25175C19.9604 7.65333 19.1809 7.83049 18.3541 7.65333C17.0903 7.39349 16.0982 6.27144 15.9919 4.97223C15.9329 4.27537 16.11 3.63758 16.4407 3.10608C16.6533 2.77538 16.6179 2.33837 16.3344 2.0549L16.3581 2.07852Z",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4648 5.18457L18.8034 13.535",
    stroke: "#161616",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4464_31118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupom);
export default __webpack_public_path__ + "static/media/Cupom.a4a5fe48849c1b4360cd29ab11248bf0.svg";
export { ForwardRef as ReactComponent };